export var SET_DOISER_AREA_ID = 'SET_AREA_ID';
export var SET_DOISER_COUNTRY_ID = 'SET_COUNTRY_ID';
export var SET_DOISER_TYPE = 'SET_TYPE';
/**
 * Sets the doiser area ID
 *
 * @param areaId
 * @returns {function(*): *}
 */
export function setDoiserAreaId(areaId) {
    return function (dispatch) { return dispatch({
        type: SET_DOISER_AREA_ID,
        payload: areaId,
    }); };
}
/**
 * Sets the doiser country ID
 *
 * @param countryId
 * @returns {function(*): *}
 */
export function setDoiserCountryId(countryId) {
    return function (dispatch) { return dispatch({
        type: SET_DOISER_COUNTRY_ID,
        payload: countryId,
    }); };
}
/**
 * Sets the long read type
 *
 * @param type
 * @returns {function(*): *}
 */
export function setDoiserType(type) {
    return function (dispatch) { return dispatch({
        type: SET_DOISER_TYPE,
        payload: type,
    }); };
}
//# sourceMappingURL=setDoiserStates.js.mapexport var SET_DOISER_AREA_ID = 'SET_AREA_ID';
export var SET_DOISER_COUNTRY_ID = 'SET_COUNTRY_ID';
export var SET_DOISER_TYPE = 'SET_TYPE';
/**
 * Sets the doiser area ID
 *
 * @param areaId
 * @returns {function(*): *}
 */
export function setDoiserAreaId(areaId) {
    return function (dispatch) { return dispatch({
        type: SET_DOISER_AREA_ID,
        payload: areaId,
    }); };
}
/**
 * Sets the doiser country ID
 *
 * @param countryId
 * @returns {function(*): *}
 */
export function setDoiserCountryId(countryId) {
    return function (dispatch) { return dispatch({
        type: SET_DOISER_COUNTRY_ID,
        payload: countryId,
    }); };
}
/**
 * Sets the long read type
 *
 * @param type
 * @returns {function(*): *}
 */
export function setDoiserType(type) {
    return function (dispatch) { return dispatch({
        type: SET_DOISER_TYPE,
        payload: type,
    }); };
}
//# sourceMappingURL=setDoiserStates.js.map